import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
} from '@mui/material';
import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { getDataList } from '../../../helpers/getDataList';
import showMessage from '../../../helpers/showMessage';
import PageHeader from '../includes/PageHeader';
import './epg-poster.css';
import { LOCAL_STORAGE_USER, SESSION_NAME } from '../../../configs/constants';
import EpgPosterUpload from './EpgPosterUpload';
export function EpgPoster() {
    const [isLoading, setIsLoading] = useState(true);
    const [channelList, setChannelList] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [pageSize, setPageSize] = useState(100);
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    useEffect(() => {
        console.log("ajiljiiin")
        let isActive = true;

        const fetchData = async () => {
            try {
                const response = await getDataList(user?.role === "OPERATOR" ? `channel/${user?.channelId}` : 'channel');
                if (isActive) {
                    const channels = response.data?.data;
                    
                    setChannelList(channels);
                    if (channels.length > 0) {
                        setSelectedChannel(channels[0]);
                        if (channels[0]?.epgPrograms?.length > 0) {
                        }
                    }
                    setIsLoading(false);
                }
            } catch (error) {
                const message = error.response?.data?.message ? error.response.data.message : error.message;
                showMessage(message, enqueueSnackbar, 'error');
                setIsLoading(false);
            }
        };

        fetchData();

        return () => {
            isActive = false;
        };
    }, []);

    if (isLoading) return <div>Loading...</div>;

    const changeChannel = (channelId) => {
        const selectedChannel = channelList.find(({ id }) => id === channelId);
        if (selectedChannel) {
            setSelectedChannel(selectedChannel);
        } else {
            setSelectedChannel({});
        }
    };
    const localizedTextsMap = {
        columnMenuUnsort: "Ангилаагүй",
        columnMenuSortAsc: "Өсөхөөр эрэмблэх",
        columnMenuSortDesc: "Буурахаар эрэмблэх",
        columnMenuFilter: "Хайх",
        columnMenuHideColumn: "Нуух",
        columnMenuShowColumns: "Багана харах"
    };
    return (
        <div className="epg-wrapper">
            <div className="epg-channel">
                <Grid
                    container
                    justifyContent="center"
                    style={{ height: 630, width: '100%' }}
                >
                    <PageHeader pageName="ТВ суваг" showAddNew={false} />
                    {isLoading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : (user?.role == "OPERATOR" ? (
                        <DataGrid
                            rows={channelList}
                            columns={[
                                {
                                    field: 'name',
                                    headerName: 'Нэр',

                                    renderCell: (params) => {
                                        return (
                                            <Box style={{ cursor: 'pointer' }}>
                                                {params.value}
                                            </Box>
                                        );
                                    },
                                    flex: 1,
                                },
                            ]}
                            pageSize={pageSize}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            pagination
                            checkboxSelection={false}
                            disableSelectionOnClick
                                onCellClick={(params) => changeChannel(params.id)}
                                localeText={localizedTextsMap}
                        />
                        ) : (
                                <DataGrid
                            rows={channelList}
                            columns={[
                                {
                                    field: 'name',
                                    headerName: 'Нэр',

                                    renderCell: (params) => {
                                        return (
                                            <Box style={{ cursor: 'pointer' }}>
                                                {params.value}
                                            </Box>
                                        );
                                    },
                                    flex: 1,
                                },
                            ]}
                            pageSize={pageSize}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            pagination
                            checkboxSelection={false}
                            disableSelectionOnClick
                                onCellClick={(params) => changeChannel(params.id)}
                                localeText={localizedTextsMap}
                        />
                    )
                    )}
                </Grid>
            </div>
            <div className="epg-detail">
                <PageHeader
                    pageName={selectedChannel.name + `-н постер зураг оруулах хэсэг`}
                    showAddNew={false}
                />
                    <EpgPosterUpload selectedChannel={selectedChannel}/>
            </div>
        </div>
    );
}
